// document.addEventListener("DOMContentLoaded", (event) => {
$(document).ready(function() {
    // $('.cwc-card-content h4').click(function() {
    //     $(this).closest('.cwc-card-content').toggleClass('active');
    //     $(this).closest('.cwc-card-content').find('.cwc-card-content-body').slideToggle();
    // })

    $('.home-tab-inner .home-tab-tabs h3').click(function() {
        let index = $(this).data('index');
        $(this).addClass('active').siblings().removeClass('active');
        $('.home-tab-tabs-content[data-index='+index+']').addClass('active').siblings().removeClass('active');
        $('.home-tab-image img[data-index='+index+']').removeClass('hidden').siblings().addClass('hidden');
    })
  
    const lenis = new Lenis({
      autoRaf: true,
      wheelMultiplier:.7,
      easing: (t) => t * (2 - t),
      smoothWheel: true,
      smoothTouch: true
    });
    gsap.registerPlugin(ScrollTrigger);
    gsap.from(".hero-banner-content-inner>*, .hero-banner-con>*", {
        y: "100%",
        opacity:0,
        duration:1,
        stagger:.2
    });
  
      $(".top-features-inner .cwc-inner").slick({
         slidesToShow:3.8,
         infinite:false,
         slidesToScroll:1,
         arrows:false,
         responsive: [
            { breakpoint: 768, settings: { slidesToShow: 1.2, slidesToScroll: 1 } },
        ]
      });

        // gsap.to(".top-features-main .cwc-card:nth-child(2n + 1)", {
        //     scrollTrigger:{
        //         trigger: ".top-features-main",
        //         start: "0% 50%",
        //         end: "150% 100%",
        //         scrub: true
        //         // markers: true,
        //     },
        //     y: "20%"
        // });

  $(".custom-temstimonial-footer-slider").slick({
        dots:false,
        arrows:false,
        infinite:!0,
        autoplay:true,
        slidesToShow:2,
        slidesToScroll:1,
        responsive:[
          {
            breakpoint:600,
            settings:{
               slidesToShow:1,
               adaptiveHeight: true,
               dots:false
            }
          }
        ]
    });

    $('.prd-inner-btns button').on('click', function() {
      let color = $(this).text();  
      if(color == 'Rose Gold'){
          $('.prd-inner-prd').find('[data-handle="rose-gold"]').show();
          $('.prd-inner-prd').find('[data-handle="black"]').hide();
      }else{
          $('.prd-inner-prd').find('[data-handle="black"]').show();
          $('.prd-inner-prd').find('[data-handle="rose-gold"]').hide();
      }
    })

    $(".last-section-accordion-heading").click(function(){var accordion=$(this).closest(".last-section-accordion");accordion.hasClass("active")?(accordion.removeClass("active"),accordion.find(".last-section-accordion-content").slideUp()):($(".last-section-accordion").removeClass("active"),$(".last-section-accordion-content").slideUp(),accordion.addClass("active"),accordion.find(".last-section-accordion-content").slideDown())})
  
    if(window.innerWidth < 768){
        $(".top-features-2-inner .cwc-inner").slick({
           slidesToShow:1.2,
           infinite:false,
           slidesToScroll:1,
           arrows:false
        });
        gsap.to(".top-features-2-main .cwc-card:nth-child(2n + 1)", {
            scrollTrigger:{
                trigger: ".top-features-2-main",
                start: "0% 50%",
                end: "100% 100%",
                scrub: true
                // markers: true,
            },
            y: "12%"
        });

        // gsap.from(".top-features-main .card-with-content", {
        //     scrollTrigger:{
        //         trigger: ".top-features-main",
        //         start: "15% 50%",
        //         end: "80% 100%",
        //         scrub: true,
        //         // markers: true,
        //     },
        //     x: "100%",
        // });

        //  gsap.from(".multiple-role-body .cwc-inner .cwc-inner-cards .cwc-card:first-child", {
        //     scrollTrigger:{
        //         trigger: ".multiple-role-body",
        //         start: "25% 70%",
        //         end: "60% 100%",
        //         scrub: true,
        //         // markers: true,
        //     },
        //     x: "-40%",
        //     opacity:0
        // });
        // gsap.from(".multiple-role-body .cwc-inner .cwc-inner-cards .cwc-card:last-child", {
        //     scrollTrigger:{
        //         trigger: ".multiple-role-body",
        //         start: "35% 70%",
        //         end: "80% 100%",
        //         scrub: true,
        //         // markers: true,
        //     },
        //     x: "40%",
        //     opacity:0
        // });
        // gsap.from(".multiple-role-body .cwc-inner>.cwc-card", {
        //     scrollTrigger:{
        //         trigger: ".multiple-role-body",
        //         start: "0% 70%",
        //         end: "50% 100%",
        //         scrub: true,
        //         // markers: true,
        //     },
        //     x: "40%",
        //     opacity:0
        // });
    }else{
        // gsap.to(".top-features-main .top-features-center img", {
        //     scrollTrigger:{
        //         trigger: ".top-features-main",
        //         start: "2% 100%",
        //         end: "50% 100%",
        //         scrub: true,
        //         markers: true
        //     },
        //     scale: 0,
        //     y: "-20%"
        // });
        
        gsap.to(".top-features-2-main .cwc-card:nth-child(2n + 1)", {
            scrollTrigger:{
                trigger: ".top-features-2-main",
                start: "0% 50%",
                end: "100% 100%",
                scrub: true,
                // markers: true,
            },
            y: "20%"
        });

          gsap.to(".prd-inner", {
            x: "-100%",
            ease: "none",
            scrollTrigger:{
              trigger: ".prd-main",
              pin: true,
              scrub: 0.5,
              pinSpacing: true,
              start: () => "-5% top",
              end: () => '+=100%',
            }
          });
        // });
        
        gsap.from("section.banner-waterproof .image-banner-content h3", {
            scrollTrigger:{
                trigger: "section.banner-waterproof",
                start: "0% 80%",
                end: "50% 100%",
                scrub: true,
                // markers: true,
            },
            opacity: 0,
            scale:0,
            // x: "-100%",
        });
        gsap.from("section.banner-waterproof .image-banner-content p", {
            scrollTrigger:{
                trigger: "section.banner-waterproof",
                start: "0% 80%",
                end: "50% 100%",
                scrub: true,
                // markers: true,
            },
            opacity: 0,
            scale:0,
            // x: "120%",
        });
        // gsap.from("section.banner-waterproof img", {
        //     scrollTrigger:{
        //         trigger: "section.banner-waterproof",
        //         start: "0% 100%",
        //         end: "50% 100%",
        //         scrub: true,
        //         // markers: true,
        //     },
        //     opacity: .5,
        //     scale:.8
        // });
        gsap.from(".multiple-role-body .cwc-inner .cwc-inner-cards .cwc-card:first-child", {
            scrollTrigger:{
                trigger: ".multiple-role-body",
                start: "-25% 70%",
                end: "50% 100%",
                scrub: true,
                // markers: true,
            },
            x: "-40%",
            opacity:0
        });
        gsap.from(".multiple-role-body .cwc-inner .cwc-inner-cards .cwc-card:last-child", {
            scrollTrigger:{
                trigger: ".multiple-role-body",
                start: "25% 70%",
                end: "110% 100%",
                scrub: true,
                // markers: true,
            },
            x: "-40%",
            opacity:0
        });
        gsap.from(".multiple-role-body .cwc-inner>.cwc-card", {
            scrollTrigger:{
                trigger: ".multiple-role-body",
                start: "0% 70%",
                end: "110% 100%",
                scrub: true,
                // markers: true,
            },
            x: "40%",
            opacity:0
        });
        gsap.from("section.banner-records h2", {
            scrollTrigger:{
                trigger: "section.banner-records",
                start: "0% 70%",
                end: "70% 100%",
                scrub: true,
                // markers: true,
            },
            y: "40%",
            opacity:0
        });
    }

    gsap.from(".software-features-main .heading-one", {
            scrollTrigger:{
                trigger: ".software-features-main",
                start: "-15% 50%",
                end: "10% 50%",
                scrub: true,
                // markers: true,
            },
            x: "-100%",
        });
        gsap.from(".software-features-main .heading-two", {
            scrollTrigger:{
                trigger: ".software-features-main",
                start: "10% 70%",
                end: "20% 60%",
                scrub: true,
                // markers: true,
            },
            x: "100%",
        });
        gsap.from(".software-features-image-inner img", {
            scrollTrigger:{
                trigger: ".software-features-main",
                start: "10% 70%",
                end: "30% 60%",
                scrub: true,
                // markers: true,
            },
            scale: 0,
        });
        gsap.from(".software-features-main .normal-card", {
            scrollTrigger:{
                trigger: ".software-features-main",
                start: "25% 70%",
                end: "110% 100%",
                scrub: true,
                // markers: true,
            },
            scale: 0,
        });
})
// })